import { CheckoutType } from './events/ecommerce/types';
import { GAEventName } from './ga-event-name.enum';

export enum GtmEvent {
  MANUAL_EVENT = 'manual_event'
}

export interface DataLayerEvent {
  checkout_type?: CheckoutType;
  click_text?: string;
  click_url?: string;
  event_name?: string;
  event_target?: 'new';
  event?: GAEventName | GtmEvent;
  location?: string | object;
  product_category?: string;
  product_id?: string | number;
  product_name?: string;
  product_price?: string | number;
  product_quantity?: string | number;
  product_variant_id?: string | number;
  product_variant?: string;
  subscription_id?: string | number;
  link_text?: string;
  link_url?: string;
  link_type?: string;
  [key: string]: unknown;
}

export type GAEventMapper<T = void> = (payload: T) => DataLayerEvent;
